import { render, staticRenderFns } from "./v-order-discard-popup.vue?vue&type=template&id=2f50641b&scoped=true"
import script from "./v-order-discard-popup.vue?vue&type=script&lang=js"
export * from "./v-order-discard-popup.vue?vue&type=script&lang=js"
import style0 from "./v-order-discard-popup.vue?vue&type=style&index=0&id=2f50641b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f50641b",
  null
  
)

export default component.exports